import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { loginUser } from "../Utils/User";
import BlyncSyncLogo from "../Base/BlyncSyncLogo";
import Container from "../Base/Container";
import Button from "../Base/Button";

const LoginPage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
`;

const LoginForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 20px;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;

    label {
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 12px;

      input {
        border: ${props => (props.invalid ? "solid 1px #d94a38" : "solid 1px #dbdee5")};
        padding: 10px;
        border-radius: 3px;
        font-size: 14px;
        margin-top: 4px;
      }
    }

    p.error-message {
      margin-bottom: 12px;
      color: #d94a38;
      font-size: 14px;
    }
  }
`;

const Login = () => {
  const [loginState, setLoginState] = useState({
    email: "",
    password: "",
    formInvalid: false
  });

  const updateEmail = event => {
    setLoginState({
      email: event.target.value,
      password: loginState.password,
      formInvalid: loginState.formInvalid
    });
  };

  const updatePassword = event => {
    setLoginState({
      email: loginState.email,
      password: event.target.value,
      formInvalid: loginState.formInvalid
    });
  };

  const formInvalid = () => {
    setLoginState({
      email: loginState.email,
      password: "",
      formInvalid: true
    });
  };

  return (
    <LoginPage>
      <Container width={300}>
        <LoginForm invalid={loginState.formInvalid}>
          <BlyncSyncLogo width={80} />
          <form>
            <label htmlFor="username">
              Email:
              <input
                type="text"
                name="email"
                id="email"
                autoComplete="email"
                placeholder="Email"
                onChange={updateEmail}
                value={loginState.email}
              />
            </label>

            <label htmlFor="password">
              Password:
              <input
                type="password"
                name="password"
                id="password"
                autoComplete="current-password"
                placeholder="Password"
                onChange={updatePassword}
                value={loginState.password}
              />
            </label>

            {loginState.formInvalid && <p className="error-message">You entered an invalid email or password</p>}

            <Button
              primary
              onClick={e => {
                e.preventDefault();

                loginUser(loginState.email, loginState.password).then(auth => {
                  if (typeof auth === "string") {
                    formInvalid();
                  }
                });
              }}
              onSubmit={e => {
                e.preventDefault();
              }}
            >
              Sign In
            </Button>
            <Link to="/forgot-password" style={{ textAlign: "center", marginTop: 12, color: "#6B6C6F" }}>
              Forgot Password
            </Link>
          </form>
        </LoginForm>
      </Container>
    </LoginPage>
  );
};

export default Login;
